(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medal-personalizer"] && !Shopify.designMode) return;
  try {
    
  class MedalPersonalizer extends HTMLElement {
    connectedCallback() {
      this.variantOptions = [...this.querySelectorAll('[data-variant-option]')];
      this.variantId = this.querySelector('[data-variant-id]');
      this.frontInput = this.querySelector('[data-front-input]');
      this.backInput = this.querySelector('[data-back-input]');
      this.previewText = this.querySelector('[data-preview-text]');
      this.imageInput = this.querySelector('[data-image-input]');
      this.previewImage = this.querySelector('[data-preview-image]');
      this.imageStatus = this.querySelector('[data-image-status]');
      this.imageControls = this.querySelector('[data-image-controls]');
      this.imageUrl = '';
      this.isBlack = false;
      this.currentFace = 'front';
      this.addEventListener('input', this.render);
      this.addEventListener('change', this.render);
      this.addEventListener('click', this.handleClick);
      this.imageInput.addEventListener('change', this.handleImageChange);
      this.render();
    }
    disconnectedCallback() {
      this.removeEventListener('input', this.render);
      this.removeEventListener('change', this.render);
      this.removeEventListener('click', this.handleClick);
      this.imageInput?.removeEventListener('change', this.handleImageChange);
      if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
    }
    handleClick = (event) => {
      const faceButton = event.target.closest('[data-face-button]');
      if (faceButton) {
        this.currentFace = faceButton.dataset.faceButton;
        this.querySelectorAll('[data-face-button]').forEach((button) => {
          const active = button === faceButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.renderPreview();
        return;
      }
      if (event.target.closest('[data-reset-personalization]')) {
        this.resetPersonalization();
        return;
      }
      const quantityButton = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
      if (!quantityButton) return;
      const input = this.querySelector('[data-quantity]');
      const minimum = Number(input.min) || 1;
      const maximum = Number(input.max) || 10;
      const direction = quantityButton.hasAttribute('data-quantity-increase') ? 1 : -1;
      input.value = String(Math.min(maximum, Math.max(minimum, (Number(input.value) || minimum) + direction)));
    };
    resetPersonalization() {
      if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = '';
      this.frontInput.value = '';
      this.backInput.value = '';
      this.imageInput.value = '';
      this.previewImage.removeAttribute('href');
      this.imageStatus.textContent = '';
      this.querySelector('textarea[name="properties[Instructions]"]').value = '';
      this.querySelector('input[name="properties[Validation]"]').checked = false;
      this.querySelector('[data-image-scale]').value = '100';
      this.querySelector('[data-image-x]').value = '0';
      this.querySelector('[data-image-y]').value = '0';
      const firstIcon = this.querySelector('[data-icon]');
      const firstFont = this.querySelector('[data-font]');
      if (firstIcon) firstIcon.checked = true;
      if (firstFont) firstFont.checked = true;
      this.currentFace = 'front';
      this.querySelectorAll('[data-face-button]').forEach((button) => {
        const active = button.dataset.faceButton === 'front';
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.render();
    }
    handleImageChange = () => {
      if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = '';
      this.previewImage.removeAttribute('href');
      this.previewImage.toggleAttribute('hidden', true);
      this.imageInput.setCustomValidity('');

      const file = this.imageInput.files?.[0];
      if (!file) {
        this.imageStatus.textContent = '';
        this.renderPreview();
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.imageInput.setCustomValidity('Le fichier dépasse la taille maximale de 10 Mo.');
        this.imageStatus.textContent = 'Le fichier dépasse la taille maximale de 10 Mo.';
        this.imageInput.reportValidity();
        this.renderPreview();
        return;
      }
      if (file.type === 'application/pdf' || file.name.toLocaleLowerCase('fr').endsWith('.pdf')) {
        this.imageStatus.textContent = `PDF joint : ${file.name}. Il sera contrôlé par l’atelier.`;
        this.renderPreview();
        return;
      }

      this.imageUrl = URL.createObjectURL(file);
      this.previewImage.setAttribute('href', this.imageUrl);
      this.previewImage.toggleAttribute('hidden', false);
      this.imageStatus.textContent = `Aperçu local : ${file.name}.`;
      this.renderPreview();
    };
    render = (event) => {
      if (event?.target?.matches('[data-icon]') && this.imageUrl) this.clearImage();
      const option = this.variantOptions.find((input) => input.checked) || this.variantOptions[0];
      this.variantId.value = option?.value || '';
      const model = option?.dataset.model || '';
      const normalized = model.toLocaleLowerCase('fr');
      const black = normalized.includes(this.dataset.blackVariant.toLocaleLowerCase('fr'));
      this.isBlack = black;
      const shape = normalized.includes('chat') ? 'cat' : normalized.includes('os') ? 'bone' : 'round';
      this.currentShape = shape;
      this.querySelectorAll('[data-shape]').forEach((node) => node.toggleAttribute('hidden', node.dataset.shape !== shape));
      const roundBody = this.querySelector('[data-round-body]');
      if (roundBody) roundBody.setAttribute('fill', black ? this.dataset.blackFill : this.dataset.steelFill);
      this.frontInput.maxLength = 14;
      if ([...this.frontInput.value].length > this.frontInput.maxLength) this.frontInput.value = [...this.frontInput.value].slice(0, this.frontInput.maxLength).join('');
      this.querySelector('[data-front-count]').textContent = [...this.frontInput.value].length;
      this.querySelector('[data-front-limit]').textContent = this.frontInput.maxLength;
      this.querySelector('[data-back-count]').textContent = [...this.backInput.value].length;
      this.querySelector('[data-price]').textContent = option?.dataset.price || '';
      const blackOptions = this.querySelector('[data-black-options]');
      const iconOptions = this.querySelector('[data-icon-options]');
      blackOptions.hidden = false;
      const supportsIcons = shape !== 'bone';
      iconOptions.hidden = !supportsIcons;
      iconOptions.querySelectorAll('input').forEach((input) => { input.disabled = !supportsIcons; });
      this.querySelector('[data-engraving]').style.fill = black ? '#f5f2e8' : '#333';
      this.renderPreview();
    };
    clearImage() {
      if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = '';
      this.imageInput.value = '';
      this.previewImage.removeAttribute('href');
      this.imageStatus.textContent = '';
      this.querySelector('[data-image-scale]').value = '100';
      this.querySelector('[data-image-x]').value = '0';
      this.querySelector('[data-image-y]').value = '0';
    }
    renderPreview() {
      const source = this.currentFace === 'back' ? this.backInput : this.frontInput;
      const raw = source.value.trim();
      this.previewText.textContent = raw || 'Exemple';
      const iconsVisible = this.currentFace === 'front' && !this.querySelector('[data-icon-options]').hidden;
      const customImageVisible = this.currentFace === 'front' && Boolean(this.imageUrl);
      this.previewImage.toggleAttribute('hidden', !customImageVisible);
      this.imageControls.toggleAttribute('hidden', !this.imageUrl);
      this.updateImageTransform();
      const bone = this.currentShape === 'bone';
      this.previewText.setAttribute('x', bone ? '225' : '210');
      this.previewText.setAttribute('y', bone ? '239' : customImageVisible ? '305' : '242');
      this.previewText.style.paintOrder = customImageVisible ? 'stroke fill' : '';
      this.previewText.style.stroke = customImageVisible ? (this.isBlack ? '#171717' : '#f4f4f2') : 'none';
      this.previewText.style.strokeWidth = customImageVisible ? '5px' : '0';
      const selectedIcon = this.querySelector('[data-icon]:checked')?.dataset.icon || 'none';
      this.querySelectorAll('[data-preview-icon]').forEach((icon) => {
        icon.toggleAttribute('hidden', customImageVisible || !iconsVisible || selectedIcon === 'none' || icon.dataset.previewIcon !== selectedIcon);
      });
      const selectedFont = this.querySelector('[data-font]:checked')?.dataset.font || 'Arial';
      const fonts = { Arial: 'Arial, sans-serif', Georgia: 'Georgia, serif', 'Segoe Script': '"Segoe Script", cursive', 'Comic Sans MS': '"Comic Sans MS", cursive' };
      this.previewText.style.fontFamily = fonts[selectedFont] || fonts.Arial;
      requestAnimationFrame(() => this.fitText());
    }
    updateImageTransform() {
      const scale = Number(this.querySelector('[data-image-scale]').value) / 100;
      const offsetX = Number(this.querySelector('[data-image-x]').value);
      const offsetY = Number(this.querySelector('[data-image-y]').value);
      const bounds = {
        round: { width: 296, height: 296, centerX: 210, centerY: 244 },
        cat: { width: 264, height: 258, centerX: 210, centerY: 241 },
        bone: { width: 332, height: 134, centerX: 210, centerY: 239 }
      }[this.currentShape || 'round'];
      const width = bounds.width * scale;
      const height = bounds.height * scale;
      this.previewImage.setAttribute('width', String(width));
      this.previewImage.setAttribute('height', String(height));
      this.previewImage.setAttribute('x', String(bounds.centerX - width / 2 + offsetX));
      this.previewImage.setAttribute('y', String(bounds.centerY - height / 2 + offsetY));
      const clipId = this.previewImage.dataset[`${this.currentShape || 'round'}Clip`];
      this.previewImage.setAttribute('clip-path', `url(#${clipId})`);
    }
    fitText() {
      const targetWidth = this.querySelector('[data-shape="bone"]:not([hidden])') ? 180 : this.querySelector('[data-shape="cat"]:not([hidden])') ? 210 : 250;
      const customImageVisible = this.currentFace === 'front' && Boolean(this.imageUrl);
      const baseSize = customImageVisible ? 46 : 56;
      const maximumSize = customImageVisible ? 54 : 68;
      this.previewText.style.fontSize = `${baseSize}px`;
      const measured = this.previewText.getComputedTextLength();
      if (measured > 0) this.previewText.style.fontSize = `${Math.min(maximumSize, Math.max(18, baseSize * targetWidth / measured))}px`;
    }
  }
  if (!customElements.get('medal-personalizer')) customElements.define('medal-personalizer', MedalPersonalizer);

  } catch(e) { console.error(e); }
})();
})();
